import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/dashboard";
import Create from "./pages/create";
import Template from './pages/template'

function App() {
  return (
    <div>
            <BrowserRouter>
                <Routes>
                    <Route path='/' element={<Dashboard />} />
                    <Route path='/template' element={<Template />} />
                    <Route path='/create' element={<Create />} />
                </Routes>
            </BrowserRouter>
        </div>
  );
}

export default App;
